import { createFileRoute } from "@tanstack/react-router";
import PaymentInfoPage from "@/site/pages/payment-info";

// Old app's payment/subscription settings lived at /payment (section tab "Payment Info").
//
// `?recover=1` (dunning mail: "Update your card") opens inline card recovery;
// `?resume=<card_send_id>` (send-failed-lapsed mail) opens the plan picker and
// returns to that card. A SOFT session gets ONLY that action (PRD 08 D18b);
// a full session gets the normal page with the dialog pre-opened.
export type PaymentSearch = { recover?: string; resume?: string };
export const Route = createFileRoute("/payment")({
  validateSearch: (search: Record<string, unknown>): PaymentSearch => ({
    recover:
      typeof search.recover === "string" || typeof search.recover === "number" ? "1" : undefined,
    resume:
      typeof search.resume === "string" && /^[A-Za-z0-9-]{1,40}$/.test(search.resume)
        ? search.resume
        : undefined,
  }),
  component: PaymentInfoPage,
});
